import { ajaxAuth } from "@tm/utils"
import { WebserviceUrl } from "../../../webserviceUrls"
import { StoreOAuthTokenRequest } from "./models"

export async function storeOAuthToken(request: StoreOAuthTokenRequest): Promise<void> {
    const url = `${WebserviceUrl.AuthorityExternalAuthentication}/StoreOAuthToken`

    await ajaxAuth<void>({ url, body: request, method: "POST" }, undefined, undefined, true)
}
